import { useDeviceType } from '@/utils/hooks/useMediaQuery'
import { css } from '@emotion/react'
import { MailFilledIcon } from '@ruguoapp/jike-fe-icons'
import type { HTMLAttributes } from 'react'
import Tooltip from './Tooltip'

export interface UnreadNotificationTooltipProps extends HTMLAttributes<HTMLDivElement> {
	data: number
}

export default function UnreadNotificationTooltip({
	data,
	...props
}: UnreadNotificationTooltipProps) {
	const { isMobile } = useDeviceType()
	const isOpen = data > 0

	return (
		<Tooltip
			opened={isOpen}
			position={isMobile ? 'bottom' : 'left'}
			offset={isMobile ? 10 : 20}
			content={
				<div
					css={css`
						display: flex;
						align-items: center;
						gap: 4px;

						color: var(--solid-gray-4);
					`}
				>
					<MailFilledIcon
						css={css`
							width: 20px;
							height: 20px;
						`}
					/>
					<span>{data}</span>
				</div>
			}
		>
			<div
				css={css`
					height: 28px;
				`}
				{...props}
			/>
		</Tooltip>
	)
}
